import type { ValueOf } from './alias.type';

export type Size = {
  width: number;
  height: number;
};

export type Point = {
  x: number;
  y: number;
};

export const positions = {
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom',
} as const;
export type Position = ValueOf<typeof positions>;
